import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { ProductImage } from './ProductImage';
export function FinalCTA() {
  return <section className="py-6 px-4 sm:px-6 bg-navy text-white text-center" data-id="element-39" data-mp="3ueqfl8yh8xe2">
      <h2 className="text-2xl sm:text-4xl font-display text-gold leading-none mb-2" data-id="element-40" data-mp="c83nlescnc2w">
        Une dernière opportunité
      </h2>

      <div className="max-w-2xl mx-auto text-[12.5px] sm:text-base text-cream/90 leading-snug space-y-1.5 mb-4" data-id="element-41" data-mp="m4ym3xomhch6">
        <p data-id="element-42" data-mp="h659s8l2nril">
          Chaque séance est une occasion d'aider vos participants à rester
          actifs, autonomes et en meilleure santé.
        </p>
        <p data-id="element-43" data-mp="vu8ab2gcib00">
          Ne perdez plus des heures à préparer chaque cours. Avec SENIOR FITNESS
          PRO™, vous disposez d'un système complet pour organiser vos séances,
          construire des progressions efficaces et accompagner vos groupes avec
          davantage de méthode.
        </p>
        <p className="font-heading font-bold text-gold" data-id="element-44" data-mp="zxy0txgkz2no">
          Offrez-vous enfin l'outil que vous auriez aimé avoir dès le début de
          votre carrière.
        </p>
      </div>

      <div className="mb-3" data-id="element-45" data-mp="2h4izstjmtko3">
        <ProductImage className="max-w-[190px]" data-id="element-46" data-mp="2h5u54xsq70hb" />
      </div>

      <div className="bg-navy-dark border border-gold/30 rounded-lg p-3.5 mb-3 max-w-md mx-auto" data-id="element-47" data-mp="2m1sw8t5fuwlf">
        <p className="font-display text-xl sm:text-2xl tracking-wide text-white leading-none mb-1" data-id="element-48" data-mp="2r2ypqt6xanw0">
          SENIOR FITNESS PRO™
        </p>
        <p className="text-[12.5px] text-cream/85 mb-2 leading-snug" data-id="element-49" data-mp="2v1oetj1bptvh">
          Le Système Complet de Planification 6-en-1 + 5 Bonus Premium
        </p>
        <p className="text-[13px] text-cream/60 mb-0.5" data-id="element-50" data-mp="34uddfdbrzd9e">
          Prix habituel : <span className="line-through" data-id="element-51" data-mp="39s5ccrau7zn3">97 €</span>
        </p>
        <p className="text-3xl sm:text-4xl font-display text-gold leading-none" data-id="element-52" data-mp="39uht514v03yk">
          Aujourd'hui seulement : 27 €
        </p>
      </div>

      <div className="mb-1.5 max-w-lg mx-auto" data-id="element-53" data-mp="3isld3t074so9">
        <CTAButton data-id="element-54" data-mp="3itd3mpexs07o">🚀 OUI ! JE VEUX SENIOR FITNESS PRO™</CTAButton>
      </div>
      <p className="text-[11px] font-semibold text-cream/80 mb-2" data-id="element-55" data-mp="1jp4vxveuv9pz">
        Accès immédiat • Livraison instantanée par e-mail
      </p>

      <TrustRow dark data-id="element-56" data-mp="1enfiya82olz9" />
    </section>;
}